import { useBlockProps, InnerBlocks, RichText } from "@wordpress/block-editor";
import '../tw_style.css';

const ALLOWED_BLOCKS = ["cgblocks/gallery-masonry"];

const TEMPLATE = [
	[
		"core/group",
		{
			className: "swiper-slide", // Clase para cada columna (diapositiva)
		},
		[
			["cgblocks/gallery-masonry"], // Bloque permitido dentro de cada columna
		],
	],
	[
		"core/group",
		{
			className: "swiper-slide", // Clase para cada columna (diapositiva)
		},
		[
			["cgblocks/gallery-masonry"], // Bloque permitido dentro de cada columna
		],
	],
];

const Edit = (props) => {
	const { attributes, setAttributes } = props;
	const { titleOne, titleTwo } = attributes;
	return (
		<section {...useBlockProps({ className: "cg-blocks-wrapper-class relative my-20" })}>
			<div className="absolute z-0 h-40 rounded-md opacity-50 -top-6 rect-selector bg-cgBlue-brandbook w-36"></div>

			<div className="relative z-10 py-4 my-10 bg-cgWhite-ContrastTrue md:py-10">
				<div className="!w-10/12 thumb-swiper-instalations swiper bg-cgWhite-ContrastTrue">
					<div className="items-center md:justify-center swiper-wrapper">
						<div className="swiper-slide">
							<RichText
								tagName="h5"
								id="cg_block_titleOne"
								className="text-center transition-all cursor-pointer"
								value={titleOne}
								onChange={(value) => setAttributes({ titleOne: value })}
							/>
						</div>
						<div className="swiper-slide">
							<RichText
								tagName="h5"
								id="cg_block_titleTwo"
								className="text-center transition-all cursor-pointer"
								value={titleTwo}
								onChange={(value) => setAttributes({ titleTwo: value })}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="my-10">
				<div className="swiper swiper-instalations">
					<div className="swiper-wrapper">
						<InnerBlocks template={TEMPLATE} allowedBlocks={ALLOWED_BLOCKS} />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Edit;
